<app-side-menu>
  <div class="bank-transactions-container">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <div>
              <h1 class="page-title">
                <i class="fas fa-university me-3"></i>
                Transações Bancárias
              </h1>
              <p class="page-subtitle">Visualize e concilie transações por período</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bank-transactions-card">
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label class="form-label">Período:</label>
          <div class="d-flex gap-2">
            <input type="date" class="form-control" [(ngModel)]="startDate" (change)="onDateRangeChange()"/>
            <span class="align-self-center">até</span>
            <input type="date" class="form-control" [(ngModel)]="endDate" (change)="onDateRangeChange()"/>
          </div>
        </div>

        <div class="filter-group d-flex align-items-center">
          <input type="checkbox" class="form-check-input me-2" [checked]="showUnlinked" (change)="onToggleUnlinked()"/>
          <label class="form-label mb-0">Mostrar não conciliadas</label>
        </div>

        <div class="filter-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="startDate=''; endDate=''; applyFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
          <button type="button" class="btn btn-primary ms-2" (click)="openNew()">
            <i class="fas fa-plus me-2"></i>
            Novo
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="showForm" class="mt-3">
      <div class="card p-3">
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Data</label>
            <input type="date" class="form-control" [(ngModel)]="formData.transactionDate"/>
          </div>
          <div class="col-md-5">
            <label class="form-label">Descrição</label>
            <input type="text" class="form-control" [(ngModel)]="formData.description"/>
          </div>
          <div class="col-md-2">
            <label class="form-label">Valor</label>
            <input type="number" class="form-control" [(ngModel)]="formData.amount"/>
          </div>
          <div class="col-md-2">
            <label class="form-label">Tipo</label>
            <select class="form-select" [(ngModel)]="formData.type">
              <option value="Credit">Crédito</option>
              <option value="Debit">Débito</option>
            </select>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button type="button" class="btn btn-outline-secondary me-2" (click)="cancelForm()">Cancelar</button>
          <button type="button" class="btn btn-success" (click)="submitForm()">{{ editMode ? 'Salvar' : 'Criar' }}</button>
        </div>
      </div>
    </div>

    <div *ngIf="!error && (loading || transactions.length > 0)" class="table-content">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="transactions"
        [loading]="loading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [actions]="actions"
        [enableSorting]="true"
        [clientSideSort]="true"
        (actionClick)="onActionClick($event)"
        (searchChange)="onSearch($event)">
      </app-table>
    </div>

    <div *ngIf="!loading && !error && transactions.length === 0" class="empty-state">
      <i class="fas fa-file-invoice-dollar"></i>
      <h3>Nenhuma transação encontrada</h3>
      <p>Informe período ou exiba não conciliadas.</p>
    </div>

    <div *ngIf="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    </div>
  </div>
</app-side-menu>
